var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new_vip"},[_c('div',{staticClass:"content"},[_c('Employee'),_c('Judge',{attrs:{"show":_vm.showJudge},on:{"gotoNext":function($event){return _vm.gotoNext()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }